import api from '@api/api';
import { TranslateData } from '@customTypes/Api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useTranslateLandingPages = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (newOrder: TranslateData) => {
      return api.translateLandingPages(newOrder);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(['landing-pages']);
      },
    }
  );
  return { ...mutation };
};

export default useTranslateLandingPages;
